import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
	createReportSubscription,
	dtoToViewModel,
} from "services/reportSubscriptions";
import { showError, showSuccess } from "../../../../redux/common/actions";

// Standalone create operation for callers (page Headers) that only need to
// post a new subscription and don't want the full subscription list fetched
// on mount. The profile-card hook (useReportSubscriptions) still owns list
// state and pushes new view-models into it locally on success — this hook
// optionally calls onSuccess(vm) so that wiring stays possible.
export const useCreateReportSubscription = ({ onSuccess } = {}) => {
	const dispatch = useDispatch();

	return useCallback(
		async (apiBody) => {
			const res = await createReportSubscription(apiBody);
			if (!res?.status) {
				dispatch(
					showError(res?.data?.error || "Could not create subscription")
				);
				return null;
			}
			const vm = dtoToViewModel(res.data);
			dispatch(showSuccess("Report subscription created."));
			onSuccess?.(vm);
			return vm;
		},
		[dispatch, onSuccess]
	);
};
